<template>
    <modal @close="cancelEdit" dialog="modal-lg" class="eventEdit-modal view dark-top">

        <div slot="title" class="fs-large mt-4 mb-3 text-center" v-if="getIsCreatSingleEvent">
          Create New Event
        </div>

        <div slot="title" class="fs-large mt-4 mb-3 text-center" v-else>
          {{getSelectedEvent.product.name}}
        </div>

        <div slot="body" class="eventEditBody d-flex">

            <div v-if="isloadingEvent" class="text-center p-5">
                <loader></loader>
            </div>

            <div v-else class="d-flex w-100">
              <div class="col-md-3 bg-lighter darker font-weight-600 px-0 flexGrow1">
                <ul class="pt-1">
                  <li class="py-3 pl-3 pointer" :class="{'bg-light':button.selected}" @click="selectLeftButton(button)" v-for="button in leftButtons">{{button.label}}</li>
                </ul>
              </div>
              <div class="col-md-9">
                <div :is="activeArea" :validations="$v" class="pb-4"></div>
              </div>
            </div>

        </div>

        <div slot="footer">
            <footerButtons v-on:cancelEdit="cancelEdit" :validations="$v"></footerButtons>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import Loader from '@/tools/loaders/loader1'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    import areaDateTime from './EventEdit/areaDateTime'
    import areaStatus from './EventEdit/areaStatus'
    import areaCapacity from './EventEdit/areaCapacity'
    import areaResources from './EventEdit/areaResources'
    import areaSalesPermissions from './EventEdit/areaSalesPermissions'
    import areaBookingQuestion from './EventEdit/areaBookingQuestion'
    import areaPrices from './EventEdit/areaPrices'
    import areaTransports from './EventEdit/areaTransports'

    import footerButtons from './EventEdit/footerButtons'

    export default {
        created: function() {
            if(this.getIsCreatSingleEvent){
                this.getSelectedEvent.channelCommissions = this.getSalesChannelsForNewProduct
            } else {
                //saves a copy of the event to apply in case of cancel edit
                this.unModifiedEvent = JSON.parse(JSON.stringify(this.getSelectedEvent))
            }


            // set custom agents flag
            if(this.getSelectedEvent.salesPermissionsAgentsList && this.getSelectedEvent.salesPermissionsAgentsList.length > 0){
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', true)
            } else {
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', false)
            }
        },
        mounted: function() {
            //opens editevent modal with the last known area selected
            if(this.getEditEventTab){
                this.setActiveArea(this.getEditEventTab);
            } else {
                this.setActiveArea('areaDateTime');
            }
        },
        data: function() {
            return {
                unModifiedEvent: null,
                activeArea: 'areaDateTime',
                isloadingEvent: false
            }
        },
        validations: {
            getSelectedEvent: {
                product: {
                    isProductValid () {
                        return this.valdiateProduct;
                    }
                },
                location: {
                    required
                },
                resources: {
                    hasResources () {
                        return this.validateResources
                    }
                },
                end: {
                    //validates event duration
                    isValidDuration () {
                        return this.validateDuration;
                    }
                },
                salesChannelsAgent: {
                    validateAgentChannel() {
                        return this.validateSalesChannelAgents
                    }
                }
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedEvent',
                'getEditEventTab',
                'getIsCreatSingleEvent',
                'getSalesChannelsForNewProduct',
            ]),
            leftButtons: function() {
                if(this.getIsCreatSingleEvent){
                    return [
                        {
                            label:'Date / Location',
                            selected: true,
                            area: 'areaDateTime'
                        },
                        {
                            label:'Resources / Capacity',
                            selected: false,
                            area: 'areaResources'
                        },
                        // {
                        //     label:'Capacity',
                        //     selected: false,
                        //     area: 'areaCapacity'
                        // },
                        {
                            label:'Prices',
                            selected: false,
                            area: 'areaPrices'
                        },
                        // {
                        //     label:'Pickups',
                        //     selected: false,
                        //     area: 'areaTransports'
                        // },
                        {
                            label:'Sales Channels',
                            selected: false,
                            area: 'areaSalesPermissions'
                        },
                        {
                            label:'Booking Question',
                            selected: false,
                            area: 'areaBookingQuestion'
                        },
                    ]
                } else {
                    return [
                        {
                            label:'Date / Location',
                            selected: true,
                            area: 'areaDateTime'
                        },
                        {
                            label:'Status',
                            selected: false,
                            area: 'areaStatus'
                        },
                        // {
                        //     label:'Capacity',
                        //     selected: false,
                        //     area: 'areaCapacity'
                        // },
                        {
                            label:'Resources / Capacity',
                            selected: false,
                            area: 'areaResources'
                        },
                        {
                            label:'Prices',
                            selected: false,
                            area: 'areaPrices'
                        },
                        {
                            label:'Sales Channels',
                            selected: false,
                            area: 'areaSalesPermissions'
                        },
                        // {
                        //     label:'Pickups',
                        //     selected: false,
                        //     area: 'areaTransports'
                        // },
                        {
                            label:'Booking Question',
                            selected: false,
                            area: 'areaBookingQuestion'
                        },
                    ]
                }
            },
            valdiateProduct: function () {
                if(!this.getIsCreatSingleEvent || this.getIsCreatSingleEvent == false){
                    return true
                } else {
                    if(!this.getSelectedEvent.helperProduct || this.getSelectedEvent.helperProduct == null){
                        return false
                    } else {
                        return true
                    }
                }
            },
            validateDuration: function () {
                let timeDiff = moment(this.getSelectedEvent.end).diff(moment(this.getSelectedEvent.start), 'minutes');
                return timeDiff > 0;
            },
            validateResources: function () {
                // if availbility is "Limited by Resources" we need to make sure that the event has resources
                if(this.getSelectedEvent.availabilityType == 2){
                    return this.getSelectedEvent.eventResources.length > 0
                } else {
                    return true
                }
            },
            validateSalesChannelAgents: function () {
                let agentsChannel = this.getSelectedEvent.channelCommissions.filter(channel => {
                    return channel.channelType == 50
                })

                if (agentsChannel.length > 0) {
                    agentsChannel = agentsChannel[0]
                } else {
                    return false
                }

                if(agentsChannel.isActive && this.getSelectedEvent.salesPermissionsAgentsCustom == true && this.getSelectedEvent.salesPermissionsAgentsList.length == 0){
                    return false
                } else {
                    return true
                }
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'closeModal',
                'updateEditEventTab',
                'cancelEventEdit',
                'updateSelectedEvent'
            ]),

            selectLeftButton: function(button){
                for (let leftButton of this.leftButtons) {
                    leftButton.selected = false;
                }
                button.selected = true;
                this.activeArea = button.area;
                this.updateEditEventTab(button.area);
            },
            setActiveArea: function(areaName){
                for (let leftButton of this.leftButtons) {
                    if(leftButton.area == areaName){
                        leftButton.selected = true;
                        this.activeArea = areaName;
                    } else {
                        leftButton.selected = false;
                    }
                }
            },
            cancelEdit: function() {
                //this.getSelectedEvent = this.unModifiedEvent;
                this.cancelEventEdit(this.unModifiedEvent)
                this.closeModal();
            }
        },
        components: {
            Modal,
            footerButtons,
            areaDateTime,
            areaStatus,
            areaCapacity,
            areaResources,
            areaSalesPermissions,
            areaBookingQuestion,
            areaPrices,
            areaTransports,
            Loader
        }
    }
</script>

<style lang="scss">
// not scopped so it affects modal-body, parent eventEdit-modal used instead of scooped
.eventEdit-modal {
    .modal-body{
        // height: 38rem !important;
    }

    .overflowAuto{
        overflow: auto;
    }
}
</style>

<style lang="scss" scoped>
    .eventEditBody{
        min-height: 460px;
    }
</style>



// WEBPACK FOOTER //
// EventEdit.vue?00b185a8